import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/Termos";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/termos")({
  head: () =>
    pageHead({
      title: "Termos de Uso | Clara Camille Nutricionista",
      description: "Termos de uso do site da Clara Camille, nutricionista brasileira na Austrália.",
      path: "/termos",
    }),
  component: Page,
});
